import {Service} from '@s-ui/domain'

export default class GetPageNamePageService extends Service {
  constructor({config, mapper}) {
    super({config, mapper})

    this._config = config
    this._mapper = mapper
  }

  execute = async ({path}) => this._mapper.map({path}).toJSON()
}
